jQuery(($) => {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el, $markers = false) {
    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 8,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // var zoomControlDiv = document.createElement('div');
    // var zoomControl = new ZoomControl(zoomControlDiv, map);
    // zoomControlDiv.index = 1;
    // map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(zoomControlDiv);

    // zoomControlDiv.setAttribute("class", "custom-zoom-wrapper")

    // Add me
    if (GOOGLEMAP.me['geo_point.location']) {
      map.me = new google.maps.Marker({
        position: {
          lat: parseFloat(GOOGLEMAP.me['geo_point.location'].lat),
          lng: parseFloat(GOOGLEMAP.me['geo_point.location'].lng),
        },
        map: map,
      });
    }

    // Add markers.
    map.markers = [];
    if ($markers) {
      $markers.each(function () {
        initMarker($(this), map);
      });
    }

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var locationID = $marker.data('location-id');
    var locationID = locationID.toString();

    if (!lat || !lng) return;

    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: GOOGLEMAP.icons.blue,
        origin: new google.maps.Point(0, 0),
      },
      title: locationID,
      element: $marker,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // Handle click event on marker
    google.maps.event.addListener(marker, 'click', function () {
      map.markers.forEach(function (marker) {
        marker.element.removeClass('js-map-marker--active');
        marker.setIcon({
          url: GOOGLEMAP.icons.blue,
          origin: new google.maps.Point(0, 0),
        });
      });

      $marker.addClass('js-map-marker--active');
      marker.setIcon({
        url: GOOGLEMAP.icons.red,
        origin: new google.maps.Point(0, 0),
      });

      document.querySelector('.js-map-marker--active').scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    });
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    let ne = bounds.getNorthEast();
    let sw = bounds.getSouthWest();
    let lat = ne.lat();
    let diff = lat - sw.lat();
    let newlat = lat + (136 * diff) / $('.js-map').height();

    bounds.extend({
      lat: newlat,
      lng: ne.lng(),
    });

    // if no markers
    if (map.markers.length == 0) {
      if (map.me) {
        map.setCenter(map.me.getPosition());
      } else {
        map.setCenter({
          lat: 41.850033,
          lng: -87.6500523,
        });
        map.setZoom(4);
      }
      // Case: Single marker.
    } else if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      // Case: Multiple markers.
    } else {
      if (map.me) {
        bounds.extend({
          lat: map.me.position.lat(),
          lng: map.me.position.lng(),
        });
      }

      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function () {
    if ($('.js-map').length == 0) return;
    
    let map = initMap($('.js-map'), $('.js-map-marker'));

    // passing in this DIV.
    $(window).load(function () {
      if (!('geolocation' in navigator)) {
        $('.js-find-location').hide();
      }
    });

    $('.js-search-text').on('focus', function () {
      $('.js-find-location').addClass('js-find-location--show')
    })
    $('.js-search-text').on('blur', function () {
      $('.js-find-location').removeClass('js-find-location--show')
    })
    $('.js-search-text ~ button[type="reset"]').on('click', function () {
      $('.js-search-text').val('');
      $('.js-form').submit();
    })

    $('.js-find-location').on('click', function () {
      $(this).addClass('js-find-location--loading');
      $(this).removeClass('js-find-location--success');
      $(this).removeClass('js-find-location--error');

      navigator.geolocation.getCurrentPosition(
        (location) => {
          $('.js-search-text').val('');
          $('.js-search-lat').val(location.coords.latitude);
          $('.js-search-lng').val(location.coords.longitude);

          $(this).addClass('js-find-location--success');
          $(this).removeClass('js-find-location--loading');
          $('.js-form').submit();
        },
        (error) => {
          $(this).addClass('js-find-location--error');
          $(this).removeClass('js-find-location--loading');
        }
      );
    });
  });

  /**
   * The ZoomControl adds +/- button for the map
   *
   */

  // function ZoomControl(controlDiv, map) {

  //     // Creating divs & styles for custom zoom control
  //     controlDiv.style.padding = '5px';

  //     // Set CSS for the control wrapper
  //     var controlWrapper = document.createElement('div');
  //     controlWrapper.style.backgroundColor = 'white';
  //     controlWrapper.style.borderStyle     = 'solid';
  //     controlWrapper.style.borderColor     = 'gray';
  //     controlWrapper.style.borderWidth     = '1px';
  //     controlWrapper.style.cursor          = 'pointer';
  //     controlWrapper.style.textAlign       = 'center';
  //     controlWrapper.style.width           = '32px';
  //     controlWrapper.style.height          = '64px';
  //     controlDiv.appendChild(controlWrapper);

  //     // Set CSS for the zoomIn
  //     var zoomInButton = document.createElement('div');
  //     zoomInButton.style.width  = '32px';
  //     zoomInButton.style.height = '32px';
  //     /* Change this to be the .png image you want to use */
  //     zoomInButton.style.backgroundImage = 'url("http://placehold.it/32/00ff00")';
  //     controlWrapper.appendChild(zoomInButton);

  //     // Set CSS for the zoomOut
  //     var zoomOutButton = document.createElement('div');
  //     zoomOutButton.style.width  = '32px';
  //     zoomOutButton.style.height = '32px';
  //     /* Change this to be the .png image you want to use */
  //     zoomOutButton.style.backgroundImage = 'url("http://placehold.it/32/0000ff")';
  //     controlWrapper.appendChild(zoomOutButton);

  //     // Setup the click event listener - zoomIn
  //     google.maps.event.addDomListener(zoomInButton, 'click', function () {
  //         map.setZoom(map.getZoom() + 1);
  //     });

  //     // Setup the click event listener - zoomOut
  //     google.maps.event.addDomListener(zoomOutButton, 'click', function () {
  //         map.setZoom(map.getZoom() - 1);
  //     });
  // }
});
